import { useCallback, useState } from 'react';
import AuditLogService from './audit-log.service';
import { AuditLogRequest, AuditLogResponse } from './audit-log.types';

export const useAuditLogs = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AuditLogResponse | null>(null);
  const [error, setError] = useState<any>(null);

  const fetchAuditLogs = useCallback(async (request: AuditLogRequest) => {
    setLoading(true);
    setError(null);
    try {
      const response = await AuditLogService.search(request);
      setData(response);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    auditLogs: { data, loading, error },
    fetchAuditLogs,
  };
};